import styled from "styled-components";

const ImageWrapper = styled.div`
  margin-bottom: 1em;
`;

export default ImageWrapper;
